import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const API_URL =
  "https://customizebychoice.com/pikchar_api/data/filenamee/titles_with_posters";

const HomeList = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch(API_URL, { cache: "no-cache" });
        const json = await res.json();
        if (json && json.success && json.data) {
          setData(json.data);
        } else {
          console.warn("Unexpected API response:", json);
        }
      } catch (e) {
        console.error("Failed to load titles:", e);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  const slideLeft = (categoryId) => {
    const slider = document.getElementById(`slider-${categoryId}`);
    if (slider) slider.scrollBy({ left: -500, behavior: "smooth" });
  };

  const slideRight = (categoryId) => {
    const slider = document.getElementById(`slider-${categoryId}`);
    if (slider) slider.scrollBy({ left: 500, behavior: "smooth" });
  };

  const viewMore = (categoryId) => {
    navigate(`/category/${categoryId}`);
  };

  return (
    <div className="md:ml-28 ml-0 relative md:-mt-20 lg:-mt-56 mt-0 z-10">
      {loading ? (
        Array(3).fill().map((_, index) => (
          <div key={index} className="overflow-x-auto">
            <div className="flex items-center justify-between max-sm:pl-4">
              <div className="md:w-[400px] w-[100px] h-[26px] bg-gray-300 rounded-md animate-pulse md:ml-5" />
            </div>

            <div className="relative flex items-center justify-start gap-5 mb-2">
              <div className="flex overflow-x-auto gap-4 md:h-[290px] h-[220px] items-center -mt-4 px-5">
                {Array(12).fill().map((_, i) => (
                  <div key={i} className="relative">
                    <div className="relative md:w-[180px] md:h-[230px] w-[130px] h-[180px]">
                      <Skeleton height="100%" width="100%" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))
      ) : (
        Object.keys(data).map((categoryId) => {
          const cat = data[categoryId] || {};
          const length = parseInt(cat.length, 10) || (() => {
            // fallback: determine max numeric key
            const keys = Object.keys(cat);
            let max = 0;
            keys.forEach(k => { const n = Number(k); if (!Number.isNaN(n) && Number.isInteger(n)) max = Math.max(max, n); });
            return max;
          })();
          const categoryTitle = cat.title || `Category ${categoryId}`;

          // build ordered items array 1..length
          const items = [];
          for (let i = 1; i <= length; i++) {
            const entry = cat[i.toString()];
            if (entry && entry.poster) {
              items.push({ code: entry.code, poster: entry.poster });
            }
          }

          // skip empty categories
          if (!items.length) return null;

          return (
            <div key={categoryId} className="overflow-x-auto">
              <div className="flex items-center justify-between max-sm:pl-4">
                <p className="font-bold sm:text-2xl text-[13px] md:ml-4 ml-1">
                  {categoryTitle}
                </p>

                <div className="sm:px-4 flex flex-row w-40 justify-end items-center font-bold opacity-55 hover:opacity-100 transition">
                  <button onClick={() => viewMore(categoryId)} className="text-xs sm:text-base">
                    View More
                  </button>
                  <MdKeyboardArrowRight className="text-2xl font-bold" />
                </div>
              </div>

              <div className="relative flex items-center justify-start gap-5 mb-2">
                <div
                  onClick={() => slideLeft(categoryId)}
                  className="absolute px-7 hover:bg-gradient-to-r from-[#0C0404] to-transparent md:h-[290px] h-[220px] flex items-center cursor-pointer z-30"
                >
                  <MdKeyboardArrowLeft className="text-white text-3xl" />
                </div>

                <div
                  id={`slider-${categoryId}`}
                  className="flex overflow-x-auto gap-4 md:h-[290px] h-[190px] items-center -mt-4 px-5"
                >
                  {items.map(item => (
                    <div key={item.code} className="relative">
                      <div className="relative md:w-[180px] md:h-[230px] sm:w-[150px] sm:h-[200px] w-[105px] h-[150px] overflow-hidden rounded-lg">
                        <Link to={`/main-list/${item.code}`}>
                          <img
                            src={item.poster}
                            alt={item.code}
                            className="w-full h-full rounded-lg transition-transform duration-300 sm:hover:scale-[1.20]"
                          />
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>

                <div
                  onClick={() => slideRight(categoryId)}
                  className="absolute right-0 flex items-center hover:bg-gradient-to-r from-transparent to-[#0C0404] h-[280px] cursor-pointer z-30"
                >
                  <MdKeyboardArrowRight className="text-white text-3xl mr-8" />
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default HomeList;
